import React, { useEffect, useState } from "react";
import { useApp } from "../../context/AppContext";
import api from "../../api";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { TYPE_COLORS } from "./AccountsTab";

export const TrialBalanceTab = ({ refreshKey }) => {
  const { t, fmt, entity } = useApp();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/reports/trial-balance?entity_id=${entity}`).then((r) => setData(r.data)).catch(() => {}); }, [entity, refreshKey]);
  if (!data) return null;
  const ok = Math.abs(data.total_debit - data.total_credit) < 0.01;
  return (
    <div className="space-y-4" data-testid="trial-balance-tab">
      <div className="flex items-center gap-3">
        <Badge variant={ok ? "default" : "destructive"} data-testid="trial-balance-status">{ok ? t("ord.balanced") : t("ord.unbalanced")}</Badge>
        <span className="text-xs text-muted-foreground">{t("ord.trialHint")}</span>
      </div>
      <Card><CardContent className="p-0">
        <Table>
          <TableHeader><TableRow><TableHead>{t("ledger.code")}</TableHead><TableHead>{t("ledger.account")}</TableHead><TableHead>{t("common.type")}</TableHead>
            <TableHead className="text-right">{t("ledger.debit")}</TableHead><TableHead className="text-right">{t("ledger.credit")}</TableHead>
            <TableHead className="text-right">{t("ord.balanceDebit")}</TableHead><TableHead className="text-right">{t("ord.balanceCredit")}</TableHead></TableRow></TableHeader>
          <TableBody>
            {data.rows.map((r) => (
              <TableRow key={r.code} data-testid={`tb-row-${r.code}`}>
                <TableCell className="font-mono text-xs">{r.code}</TableCell><TableCell className="text-sm">{r.name}</TableCell>
                <TableCell><Badge className={`${TYPE_COLORS[r.type]} text-[10px]`}>{t(`ord.type.${r.type}`)}</Badge></TableCell>
                <TableCell className="text-right font-mono text-xs">{fmt(r.debit)}</TableCell><TableCell className="text-right font-mono text-xs">{fmt(r.credit)}</TableCell>
                <TableCell className="text-right font-mono text-xs">{r.balance_debit ? fmt(r.balance_debit) : ""}</TableCell><TableCell className="text-right font-mono text-xs">{r.balance_credit ? fmt(r.balance_credit) : ""}</TableCell>
              </TableRow>
            ))}
            <TableRow className="bg-muted/40 font-semibold">
              <TableCell colSpan={3}>{t("common.total")}</TableCell>
              <TableCell className="text-right font-mono text-xs" data-testid="tb-total-debit">{fmt(data.total_debit)}</TableCell><TableCell className="text-right font-mono text-xs" data-testid="tb-total-credit">{fmt(data.total_credit)}</TableCell>
              <TableCell className="text-right font-mono text-xs">{fmt(data.total_balance_debit)}</TableCell><TableCell className="text-right font-mono text-xs">{fmt(data.total_balance_credit)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent></Card>
    </div>
  );
};
